import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/informations/index',
    name: 'informationsIndex',
    component: () => import('@/sub-app/informations/pages/index.vue'),
    meta: {
      title: '活动资讯',
      keepAlive: true,
    },
  },
  {
    path: '/informations/list',
    name: 'informationsList',
    component: () => import('@/sub-app/informations/pages/list.vue'),
    meta: {
      title: '资讯',
      keepAlive: true,
    },
  },
  {
    path: '/informations/informationDetail',
    name: 'informationsDetail',
    component: () => import('@/sub-app/informations/pages/informationDetail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/informations/search',
    name: 'informationsSearch',
    component: () => import('@/sub-app/informations/pages/search.vue'),
    meta: {
      title: '搜索',
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
